import { SVGProps } from 'react';

const TextCursor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17 22h-1a4 4 0 0 1-4-4m0 0V6m0 12a4 4 0 0 1-4 4H7m5-4v-1m0-11a4 4 0 0 1 4-4h1m-5 4a4 4 0 0 0-4-4H7m5 4v1"
    />
  </svg>
);
export default TextCursor;
